import { createSlice } from '@reduxjs/toolkit';
import { SkladonMappingDetailStateType } from 'src/types/skladonMappingDetail';

const initialState: SkladonMappingDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};
export const skladonMappingDetailSlice = createSlice({
    name: 'skladonMappingDetail',
    initialState,
    reducers: {
        getSkladonMappingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getSkladonMappingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getSkladonMappingDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createSkladonMappingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createSkladonMappingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createSkladonMappingDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateSkladonMappingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateSkladonMappingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateSkladonMappingDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        deleteSkladonMappingFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteSkladonMappingFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteSkladonMappingFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearSkladonMappingDetail: () => initialState,
    },
});

export const {
    getSkladonMappingDetailFetch,
    getSkladonMappingDetailFetchSuccess,
    getSkladonMappingDetailFetchFailure,
    createSkladonMappingDetailFetch,
    createSkladonMappingDetailFetchSuccess,
    createSkladonMappingDetailFetchFailure,
    updateSkladonMappingDetailFetch,
    updateSkladonMappingDetailFetchSuccess,
    updateSkladonMappingDetailFetchFailure,
    deleteSkladonMappingFetch,
    deleteSkladonMappingFetchSuccess,
    deleteSkladonMappingFetchFailure,
    clearSkladonMappingDetail,
} = skladonMappingDetailSlice.actions;

export default skladonMappingDetailSlice.reducer;
